function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import VueCompositionAPI, { reactive } from '@vue/composition-api';
import Vue from 'vue';
import zhCN from '../locale/lang/zh-CN';
export var isCompositionInstall = Object.hasOwnProperty.call(Vue, '__composition_api_installed__');
if (!isCompositionInstall) {
  Vue.use(VueCompositionAPI);
}
/**
 * 全局的配置文件
 */

var globalConfigs = reactive({
  locale: zhCN,
  direction: ''
});
export var Config = {
  // 获取多语言配置
  getLocale: function getLocale() {
    return globalConfigs.locale;
  },
  // 切换多语言配置
  useLocale: function useLocale(locales) {
    globalConfigs.locale = locales;
  },
  // 修改多语言的指定key
  changeLocale: function changeLocale(locales) {
    globalConfigs.locale = _objectSpread(_objectSpread({}, globalConfigs.locale), locales);
  },
  getDirection: function getDirection() {
    var dir = document.dir === 'rtl' ? 'rtl' : 'ltr';
    return globalConfigs.direction || dir;
  },
  setDirection: function setDirection(direction) {
    globalConfigs.direction = direction;
    document.dir = direction;
  }
};
export default Config;